import { MessageBundle } from '@amzn/arb-tools';
import { Account, AdvertisingAccountType } from '@amzn/aac-chrome-internal-api';
import { getCountryCodeByMarketplace } from 'src/commons/utils/advertising-config-store/ACSConfigClient';

// Only GLOBAL reaches this check — MANAGER and DSP_ENTITY return '' at the early
// guard below before it runs, so listing DSP_ENTITY here would be unreachable
// (and misleading: it implies DSP_ENTITY shows "Multiple countries" when it
// shows nothing).
const MULTI_MARKETPLACE_ACCOUNT_TYPES = [AdvertisingAccountType.GLOBAL];

/**
 * Resolves the secondary country/marketplace label shown under an account row.
 * Manager and DSP-entity rows have none; global and multi-country Sponsored Ads
 * accounts show "Multiple countries"; single-country accounts resolve their
 * marketplace to a localized country name. Extracted from
 * IA2AccountDropdownTypeSection so the flat list can reuse it.
 */
export const getCountryLabel = ({
  accountType,
  account,
  bundle,
}: {
  accountType: AdvertisingAccountType;
  account: Account;
  bundle: MessageBundle;
}): string => {
  if (
    accountType === AdvertisingAccountType.MANAGER ||
    accountType === AdvertisingAccountType.DSP_ENTITY
  ) {
    return '';
  }

  if (MULTI_MARKETPLACE_ACCOUNT_TYPES.includes(accountType)) {
    return bundle.getMessage('account-switcher-multiple-countries');
  }

  let marketplaceId = account.marketplaceId;
  if (
    accountType === AdvertisingAccountType.SPONSORED_ADS &&
    Array.isArray(account.nestedAccounts)
  ) {
    if (account.nestedAccounts.length > 1) {
      return bundle.getMessage('account-switcher-multiple-countries');
    }

    if (account.nestedAccounts.length === 1) {
      marketplaceId = account.nestedAccounts[0]?.marketplaceId;
    }
  }

  if (!marketplaceId) {
    return '';
  }

  const countryCode = getCountryCodeByMarketplace(marketplaceId);

  if (countryCode) {
    return bundle.getMessage(`account-switcher-marketplace-${countryCode}`);
  }

  return '';
};
